"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SingleSelectTreeItemModule = /** @class */ (function () {
    function SingleSelectTreeItemModule() {
    }
    return SingleSelectTreeItemModule;
}());
exports.SingleSelectTreeItemModule = SingleSelectTreeItemModule;
